import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_address_book_contact_record_link_RowClass} from '../../../dbschema/bl_crm_address_book_contact_record_link.model'

export class CrmAddressBookContactRecordLinkContainerModel extends BaseContainerModel {
    bl_crm_address_book_contact_record_link_hdr: bl_crm_address_book_contact_record_link_RowClass = new bl_crm_address_book_contact_record_link_RowClass()
  }
